import { useEffect, useState } from 'react'
import { isEmpty } from 'lodash'

import { prepareFilters } from 'api/ApiActions/Reporting/Overview/PrepareFilters'
import { ContributionTags as ContributionTagsType } from 'types/ContributionTags'
import contributionTagsApi from 'api/ApiActions/Reporting/Overview/ContributionTags'
import usePrevious from 'lib/hooks/UsePrevious'
import { useAppSelector } from 'redux/Hook'
import { filterValues } from 'containers/Reporting/Shared/Helper'
interface ContributedTagsData {
  contributionTagsData: ContributionTagsType
  isContributionTagsLoading: boolean
}

const useContributedTags = (): ContributedTagsData => {
  const [isContributionTagsLoading, setContributionTagsLoading] =
    useState<boolean>(true)
  const [contributionTagsData, setcontributionTagsData] =
    useState<ContributionTagsType>({
      data: [],
      info: '',
    })
  const {
    filterBuilder: { selectedFilters = [] } = {},
    user: { user = {} } = {},
    stakeholderDashboardDetails: { accessToken = '', password = '' },
  }: any = useAppSelector((state) => state)
  const userFilters = filterValues(selectedFilters)
  const prevProps: any = usePrevious({ userFilters })

  const fetchContributionTagsData = async () => {
    setContributionTagsLoading(true)
    const filters = prepareFilters(selectedFilters)
    const params = { filterParams: filters, accessToken, password }
    if (!isEmpty(userFilters)) {
      const result = await contributionTagsApi.getCardData(params)

      if (!['ERR_CANCELED'].includes(result?.code)) {
        setcontributionTagsData(result)
        setContributionTagsLoading(false)
      }
    }
  }

  useEffect(() => {
    const isFilterUpdated =
      !isEmpty(userFilters) &&
      JSON.stringify(prevProps?.userFilters) !== JSON.stringify(userFilters)
    if (isFilterUpdated) {
      fetchContributionTagsData()
    }
  }, [selectedFilters])

  useEffect(() => {
    fetchContributionTagsData()
  }, [user.adminLocale])

  useEffect(() => {
    accessToken && fetchContributionTagsData()
  }, [accessToken, password])

  return {
    contributionTagsData,
    isContributionTagsLoading,
  }
}

export default useContributedTags
